module.exports = __webpack_public_path__ + "img/ug346.4388fba9.png";